import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKey = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3 17.7699L8.76999 11.9899C9.01999 11.7399 9.08001 11.3799 8.98001 11.0499C8.59001 9.81985 8.55999 8.38986 9.07999 6.96986C9.82999 4.93986 11.68 3.42985 13.82 3.07985C18.01 2.39985 21.58 5.95986 20.92 10.1499C20.51 12.7499 18.39 14.8499 15.79 15.2399C14.9 15.3799 14.05 15.3198 13.26 15.1098C12.94 15.0198 12.6 15.0999 12.36 15.3299L6.69 20.9999H3V17.7699V17.7699Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2 16.1799L9.95996 14.9299",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.35986 19.02L7.10986 17.77",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8399 10.58C15.6241 10.58 16.2599 9.94425 16.2599 9.16C16.2599 8.37576 15.6241 7.73999 14.8399 7.73999C14.0557 7.73999 13.4199 8.37576 13.4199 9.16C13.4199 9.94425 14.0557 10.58 14.8399 10.58Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgKey;
